import React from "react";
import { isAccountNumberValid } from "@norma-bi/utils";

const formatAccountNumber = (value: string) => {
  return value
    .replace(/[^\d-]/g, "")
    .replace(/(-.*)-+/g, "$1")
    .replace(/^(-)?(\d{1,6})?.*/, "$1$2");
};

export const useAccountNumberInput = (initialAccountNumber = "") => {
  const [accountNumber, setAccountNumber] = React.useState(() =>
    formatAccountNumber(initialAccountNumber),
  );

  const handleAccountNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue = formatAccountNumber(e.target.value);
    setAccountNumber(formattedValue);
  };

  return {
    accountNumber,
    handleAccountNumberChange,
    isAccountNumberValid: isAccountNumberValid(accountNumber),
  };
};
